<script>
    import KeyRecommendationModel from "./Models/keyRecommendationModel";
    import Loader from './Components/Loader.svelte';
    import {addFormModal} from './Forms/ModalFormManager.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {confirm} from './Components/Confirmation.svelte';
    import SortableTable from './Components/SortableTable.svelte';
    import {forms} from './lib/forms';
    import {tables} from './lib/tables';

    let recommendationsList = KeyRecommendationModel.getKeyRecommendationList();

    let importing;


    function addRecommendation() {
        addFormModal({
            fields: forms['keyRecommendation']
        }).then(formData => {
            KeyRecommendationModel.createKeyRecommendation(formData).then(() => notifier.success("Recommendation Added"));
        }).catch((err) => console.error(err));
    }

    function editRecommendation(recommendation) {
        addFormModal({
            fields: forms['keyRecommendation'],
            data: recommendation
        }).then(formData => {
            KeyRecommendationModel.saveKeyRecommendation(formData).then(() => notifier.success("Recommendation Saved"));
        }).catch(() => null)
    }

    function deleteRecommendation(recommendation) {
        confirm("Are you sure you want to delete this recommendation?").then(() => {
            KeyRecommendationModel.deleteKeyRecommendation(recommendation).then(() => {
                notifier.success("Recommendation Deleted");
            });
        }).catch(() => null)
    }

    let sortFields = tables['keyRecommendations'];
</script>

<Loader loading={!$recommendationsList}>
    <div class="container is-fluid">
        <h1 class="title is-1">Key Recommendations</h1>
        <SortableTable {sortFields} tableData={$recommendationsList}>
            <div slot="filterActions"><button class="button is-success" on:click={addRecommendation}>Add Key Recommendation</button></div>
            <div slot="rowActions" let:row={recommendation}>
                <div class="buttons is-centered">
                    <button class="button is-danger" on:click={() => deleteRecommendation(recommendation)}>Delete</button>
                    <button class="button is-link" on:click={() => editRecommendation(recommendation)}>Edit</button>
                </div>
            </div>
        </SortableTable>
    </div>
</Loader>

{#if importing}
    <div class="importLoader">
        <Loader></Loader>
    </div>
{/if}

<style>
    .container {
        padding-left: 32px;
        padding-right: 32px;
    }
</style>